import React from "react";

const WA_NUMBER = "40742221414";
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
  "Buna, am nevoie de suport tehnic Yvola."
)}`;

export function WhatsAppSupport() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-support-btn"
      title="Suport tehnic pe WhatsApp"
      aria-label="Suport tehnic pe WhatsApp"
      style={{
        position: "fixed",
        zIndex: 60,
        backgroundColor: "#25D366",
        color: "#ffffff",
        fontFamily: "Arial, sans-serif",
        fontSize: "13px",
        fontWeight: "bold",
      }}
      className="flex items-center justify-center gap-2 shadow-lg hover:opacity-90 transition-opacity left-4 bottom-4 right-auto w-12 h-12 rounded-full sm:left-auto sm:right-4 sm:bottom-4 sm:w-auto sm:h-auto sm:rounded-full sm:px-4 sm:py-3"
    >
      <svg viewBox="0 0 32 32" width="20" height="20" fill="currentColor" aria-hidden="true">
        <path d="M16.001 3.2C9.03 3.2 3.2 8.86 3.2 15.68c0 2.4.68 4.66 1.86 6.58L3.2 28.8l6.74-1.76a12.9 12.9 0 0 0 6.06 1.52h.01c6.97 0 12.8-5.66 12.8-12.48 0-3.34-1.34-6.48-3.75-8.84A12.86 12.86 0 0 0 16 3.2Zm0 22.8h-.01a10.7 10.7 0 0 1-5.42-1.48l-.39-.23-4 1.04 1.07-3.88-.25-.4a10.36 10.36 0 0 1-1.63-5.57c0-5.7 4.86-10.34 10.85-10.34 2.9 0 5.62 1.1 7.67 3.09a10.15 10.15 0 0 1 3.17 7.27c0 5.7-4.86 10.34-10.85 10.34Zm5.95-7.74c-.33-.16-1.93-.93-2.23-1.04-.3-.11-.52-.16-.74.16-.22.32-.85 1.04-1.04 1.25-.19.21-.38.24-.71.08-.33-.16-1.38-.5-2.63-1.6-.97-.85-1.63-1.9-1.82-2.22-.19-.32-.02-.49.14-.65.15-.14.33-.37.49-.56.16-.19.22-.32.33-.53.11-.21.05-.4-.03-.56-.08-.16-.74-1.76-1.01-2.41-.27-.64-.54-.55-.74-.56l-.63-.01c-.22 0-.57.08-.87.4-.3.32-1.14 1.11-1.14 2.71 0 1.6 1.17 3.15 1.33 3.37.16.21 2.3 3.5 5.56 4.9.78.33 1.38.53 1.85.68.78.25 1.49.21 2.05.13.63-.09 1.93-.79 2.2-1.55.27-.76.27-1.41.19-1.55-.08-.13-.3-.21-.63-.37Z" />
      </svg>
      <span className="hidden sm:inline">Suport tehnic</span>
    </a>
  );
}
